import { IgTypography } from "@intelligems/ig-theme";
import { LivePriceDto } from "@intelligems/ig-types";
import { Grid, useTheme } from "@mui/material";

import { Tag } from "./Tag";

interface HeaderRowProps {
  price: LivePriceDto;
  upcomingChange: {
    variant: string;
    word: string;
    date: string;
  } | null;
}

export const HeaderRow = ({ price, upcomingChange }: HeaderRowProps) => {
  const theme = useTheme();
  return (
    <Grid
      container
      justifyContent={"space-between"}
      sx={{ height: "36px", paddingTop: "0px !important" }}
    >
      <Grid item>
        <IgTypography variant={"body1"}>{price.product.name}</IgTypography>
      </Grid>
      <Grid item>
        <Grid container item columnSpacing={3}>
          <Grid item>
            {upcomingChange ? (
              <Tag
                variant={upcomingChange.variant as any}
              >{`${upcomingChange.word} ${upcomingChange.date}`}</Tag>
            ) : null}
          </Grid>
          <Grid item>
            {price.interval === "year" ? (
              <Tag variant={"success"}>Save 25%</Tag>
            ) : null}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
